import { Component, OnInit, Inject, Input, Output, EventEmitter } from 'ng-metadata/core';
import { BriefResultService } from '../../briefResult/briefResult.service';
import { SearchService } from "../../search.service";
import { JwtUtilService } from '../../../security/jwtUtil.service';
import { FavoritesService } from '../../../favorites/favorites.service';
import { IAlertMsg } from '../../../infra/widgets/alerts/alertMsg.interface';
import { AlertFactory, ALERT_MSG_TYPE } from '../../../infra/widgets/alerts/alertFactory.service';
import { getResultsBulkSize, getScopeList } from '../../../appConfig/appConfigForward';
import { ChangeLangService } from '../../../infra/lang/changeLang.service';
import { isBrowserIE } from '../../../infra/browserSniffer';
import { PrimolyticsService } from '../../../analytics/primolytics.service';
import { MediaQueries } from "../../../infra/mediaQueries.service";
import { ResultUtil } from "../../../nddUtils/resultUtil.service";
import { FavoritesWarningMessageService } from '../../../favorites/favoritesWarningMessage/favoritesWarningMessage.service';
import { ConfigurationUtil } from '../../../nddUtils/configurationUtil.service';
import { ExportAllService } from '../../actions/exportAll/exportAll.service';
import {UserSessionManagerService} from  '../../../security/userSessionManager.service';
import {LoginService} from '../../../security/login/login.service';
import {SearchResultToolBarService} from "./searchResultToolBar.service";

@Component({
    selector: 'prm-search-result-tool-bar',
    templateUrl: 'components/search/searchResult/searchResultToolBar/search-result-tool-bar.html',
})

export class PrmSearchResultToolBar implements OnInit {

    @Output() onClickDisableToolBar = new EventEmitter();
    @Input() private currentPageNum: number;
    @Input() private totalResults: number;
    @Input() private hasMoreResults: boolean;
    @Input() private maxResults: number;
    @Input() private totalResultVersion: number;
    @Input() private showPartialResultsWarning: boolean;
    @Input() private toggleInMobile: boolean;
    @Output() pageBulkSizeEvent = new EventEmitter<void>();
    @Input() private uiType: string;

    private SELECT_LIMIT: number = 50;
    private _showPushtoActions: boolean;
    private _showExportAllBox: boolean;
    private disableEffect: JQuery;
    private selectedAction = 'none';
    private topMaxAlert: IAlertMsg;
    private isIe = isBrowserIE();
    private scopes = getScopeList();
    private needToLoadTopMax: boolean = false;
    private insertSlideAfterDismiss: boolean = true;
    private enableTopPagination: boolean= true

    private KEY_CODE = {
        COMMA: 188,
        SEMICOLON: 186,
        ENTER: 13,
        ESCAPE: 27,
        SPACE: 32,
        PAGE_UP: 33,
        PAGE_DOWN: 34,
        END: 35,
        HOME: 36,
        LEFT_ARROW: 37,
        UP_ARROW: 38,
        RIGHT_ARROW: 39,
        DOWN_ARROW: 40,
        TAB: 9,
        BACKSPACE: 8,
        DELETE: 46
    };

    constructor(
        private briefResultService: BriefResultService,
        private favoritesService: FavoritesService,
        private searchService: SearchService,
        private jwtUtilService: JwtUtilService,
        private changeLangService: ChangeLangService,
        private favoritesWarningMessageService: FavoritesWarningMessageService,
        private alertService: AlertFactory,
        private primolyticsService: PrimolyticsService,
        private exportAllService: ExportAllService,
        private userSessionManagerService:UserSessionManagerService,
        private loginService: LoginService,
        @Inject('favoritesIcons') private favoritesIcons: Object,
        @Inject('$translate') private $translate: ng.translate.ITranslateService,
        @Inject('$element') private $element: ng.IRootElementService,
        @Inject('$scope') private $scope: ng.IScope,
        @Inject('$stateParams') private $stateParams: ng.ui.IStateParamsService,
        @Inject('$timeout') private $timeout: ng.ITimeoutService,
        @Inject('$window') private $window: ng.IWindowService,
        private mediaQueries: MediaQueries,
        private resultUtil: ResultUtil,
        private configurationUtil: ConfigurationUtil,
        private searchResultToolBarService: SearchResultToolBarService) {

        this.topMaxAlert = alertService.create(ALERT_MSG_TYPE.SIMPLE_WITHOUT_DISMISS);
        this.topMaxAlert.show('nui.brief.bulk.chooseLimit');
        this.showPushtoActions = false;
        this.showExportAllBox = false;
    }

    ngOnInit() {
        this.enableTopPagination = this.showTopPagination();
        this.$timeout(() => {
            this.removeAttDummyTab('md-tabs-dummy-wrapper span');
        }, 400);

        // Hide the Export All box when the slide disappears
        this.$scope.$watch(() => this.needToShowSlide, (needToShowSlide) => {
            if (this.showExportAllBox && !needToShowSlide) {
                this.exportAllService.resetExportAllSelection();
                this.showExportAllBox = false;
            }
        });
    }

    get pageSize() {
        return this.resultUtil.updatedBulkSize;
    }

    //========= Setters ===========
    set currPageNum(pageNum) {
        this.currentPageNum = pageNum;
    }

    set totalResultsNum(total) {
        this.totalResults = total;
    }

    set showPushtoActions(show) {
        this._showPushtoActions = show;
    }

    set showExportAllBox(show) {
        this._showExportAllBox = show;
    }

    set toggleInMobileStatus(bool) {
        this.toggleInMobile = bool;
    }

    //========= Getters ===========
    get getUser() {
        return (this.jwtUtilService.isSignedIn());
    }

    get isBrowsHeaderResults() {
        return this.$stateParams['mode'] === 'browse';
    }

    private get isAuthorityMode() {
        return this.$stateParams['mode'] === 'authority';
    }

    get needToShowSlide() {
        let checkBulkSize = this.isShowExportAllButton ? false : this.numOfVisibleResultsIsLessThanBulkSize;
        let checkSelection = this.isShowExportAllButton ? true : this.totalResultsHaveNotBeenSelectedYet;
        let notJumpToPageByPageNav = this.isShowExportAllButton ? true : this.notJumpToPageByPageNav;
        return ((this.atLeastOneRecordSelectedInThisSession || this.allIn) && !checkBulkSize) && notJumpToPageByPageNav
            && this.isNotIE && checkSelection && !this.toggleInMobileStatus;
    }

    get isShowExportTopButton(){
        if (this.isShowExportAllButton){
            return !this.numOfVisibleResultsIsLessThanBulkSize && this.notJumpToPageByPageNav;
        }
        return true;
    }

    get isNotIE() {
        return !this.isIe;
    }

    get currPageNum() {
        return this.currentPageNum;
    }

    get totalResultsNum() {
        return this.totalResults;
    }

    get toggleInMobileStatus() {
        return this.toggleInMobile;
    }

    get showPushtoActions() {
        return this._showPushtoActions;
    }

    get showExportAllBox() {
        return this._showExportAllBox;
    }

    get needToshowErrorAlert() {
        return this.selectedItems() && (this.selectedItems().length > this.SELECT_LIMIT);
    }

    getPlaceHolders(num) {
        return { idx_0: num };
    }

    get allIn() {
        return this.briefResultService.checkSearchIfAllSelected();
    }

    get notJumpToPageByPageNav() {
        return !this.briefResultService.checkIfJumpedByPageNav();
    }

    get atLeastOneRecordSelectedInThisSession() {
        // In order to insert the slide only at the **first time** user checked at least one record in this session
        return (this.selectedItems().length > 0 && this.briefResultService.selectedSearchRecordsCounter > 0) && this.insertSlideAfterDismiss;
    }

    get totalResultsHaveNotBeenSelectedYet() {
        return !(this.selectedItems() && (this.selectedItems().length === this.totalResultsNum));
    }

    get indeterminateState() {
        return !(this.briefResultService.checkSearchIfAllSelected() || this.briefResultService.getSearchChosenRecords().length === 0);
    }

    get numOfTopMax() {
        return (this.totalResultsNum && this.totalResultsNum < this.SELECT_LIMIT) ? this.totalResultsNum : this.SELECT_LIMIT;
    }

    get numOfVisibleResultsIsTheTopMax() {
        return (this.briefResultService.searchResults().length) === this.numOfTopMax;
    }

    get numOfVisibleResultsIsLessThanBulkSize() {
        return this.numOfTopMax <= this.pageSize;
    }

    get totalResultsSelected() {
        let chosenResults = this.selectedItems();
        return chosenResults && (chosenResults.length == this.totalResultsNum);
    }

    //========= Functions ==========
    public sendBriefBeacon(currOp) {
        this.primolyticsService.doBeaconReport({
            'p': 'brief',
            'op': currOp
        }, this.item, this.primolyticsService.getTimestamp());
    }

    public getAriaLive() {
        return this.needToShowSlide ? 'assertive' : 'off';
    }

    public getTabIndex() {
        return this.needToShowSlide ? '0' : '-1';
    }

    public getSelectAriaLabel() {
        return (this.allIn) ? this.$translate.instant('nui.aria.bulk.unselectAll') : this.$translate.instant('nui.aria.bulk.topCheckbox');
    }

    public selectOrUnselectAll() {
        this.briefResultService.selectAll = !this.allIn;
        this.briefResultService.searchChooseAllVisible();
        (this.allIn) ? this.sendBriefBeacon('selectDisplayedRecords') : this.sendBriefBeacon('unselectAllRecords');
    }

    public focusOnSelectTopMax() {
        if (this.needToShowSlide) {
            let element = document.getElementById('chooseTopMax');
            if (element){
                element.focus();
            } else{
                element = document.getElementById('exportAllResultsBtn');
                element.focus();
            }      
        }
    }

    public selectedItems() {
        let items = this.briefResultService.getSearchChosenItems();
        return items ? items : [];
    };

    public loadAndSelectTopMax() {
        // no need to do any thing
        if ((this.numOfVisibleResultsIsTheTopMax && !this.atLeastOneRecordSelectedInThisSession) || this.totalResultsSelected) {
            return;
        }
        this.sendBriefBeacon('selectTopRecords');

        let currLimit = (this.numOfTopMax < this.SELECT_LIMIT) ? this.numOfTopMax : this.SELECT_LIMIT;

        // need to select top max exist (already loaded) records
        if (this.searchService.numOfLoadedResultBulks >= (currLimit / this.pageSize)) {
            this.briefResultService.selectTopMax(this.numOfTopMax);
        } else {	// need to load top max new (not loaded yet) records
            this.needToLoadTopMax = true;
            this.briefResultService.loadAndSelectTopMax(this.numOfTopMax)
        }
    }

    public onTopMaxSlideClose() {
        this.exportAllService.resetExportAllSelection();
        if (this.showExportAllBox){
            this.showExportAllBox = !this.showExportAllBox;
        }
        this.searchResultToolBarService.handleToolBarOnClose();
    }

    public updateNoNeedToInsertSlideAfterDismiss() {
        this.insertSlideAfterDismiss = false;
    }

    public showButtons() {
        if (!this.needToshowErrorAlert && this.briefResultService.getSearchChosenRecords().length > 0) {
            this.disableEffect = angular.element(document.querySelector(".horizontal-content-scroller"));
            return true;
        }
        this.showPushtoActions = false;
        return false;
    }

    public pinToFavorites(event) {
        let chosenRecords = [];
        if (this.showButtons()) {
            if (this.needToLoadTopMax) {
                chosenRecords = this.selectedItems();
                this.needToLoadTopMax = false;
            } else {
                chosenRecords = this.briefResultService.getSearchChosenRecords();
            }
            this.briefResultService.pinToFavoritesFromToolBar(chosenRecords);
            this.performUpdate(event);
            this.sendBriefBeacon('addToFavoritesBulk');
        }
    }

    public switchShowPushtoActions() {
        this.showPushtoActions = this.showButtons() && !this.showPushtoActions;
        this.briefResultService.openedFromTopActionBar = this.showPushtoActions;

        // Actions in mobile - PRM-46814
        if (this.mediaQueries.xs) {
            this.$timeout(function() {
                let element = document.getElementById('actionsList');
                element.classList.add('actions-in-safari');

                // append the element to the DOM (body)
                angular.element(document.body).append(element);
            }, 100);
        }
    }

    public switchShowExportAllBox(){
        this.showExportAllBox = !this.showExportAllBox;
        if (this.showExportAllBox){
            this.$timeout(() => {
                this.focusChangeFormatDropdown();
            }, 150);
            
        }
    }

    public isChosenFav() {
        if (this.showButtons()) {
            return this.$translate.instant('nui.aria.bulk.pin');
        } else {
            return this.$translate.instant('nui.aria.bulk.pinDisabled') + ' ' + this.$translate.instant('nui.aria.favorites.enableControls');
        }
    }

    public isChosenActions() {
        if (this.showButtons()) {
            return this.$translate.instant('nui.favorites.pushto');
        } else {
            return this.$translate.instant('nui.favorites.pushtoDisable') + ' ' + this.$translate.instant('nui.aria.favorites.enableControls');
        }
    }

    closeOpenTabs(evt) {
        evt.stopPropagation();
        this.selectedAction = 'none';
    }

    public get searchInProgress() {
        return this.searchService.isSearchInProgress();
    }

    public getDir() {
        return (this.changeLangService.direction) === 'ltr' ? 'left' : 'right';
    }

    public notLocal() {
        return !this.searchService.IsScopeLocal();
    }

    public disableToolBar() {
        return this.onClickDisableToolBar.emit(event);
    }

    public keyDownSupport(e) {
        let keyCodes = this.KEY_CODE;
        if (e.keyCode === keyCodes.ESCAPE) {
            if (this.showExportAllBox){
                this.switchShowExportAllBox();
                this.exportAllService.resetExportAllSelection();
            }
            else {
                this.switchShowPushtoActions();
            }   
        }
    }

    get isShowExportAllButton(){
        return !this.exportAllService.isExportAllDisabled() && this.exportAllService.isAtLeastOneExportAllActionEnabled() && this.exportAllService.isScopeIncludesLocalOrCDI(); 
    }

    private removeAttDummyTab(str) {
        let actionButtons: [Element] = document.querySelectorAll(str);
        for (let li of actionButtons) {
            li.removeAttribute('translate');
        }
    }

    public getPageNumberPlaceHolder() {
        return { number: this.currPageNum };
    }

    private performUpdate($event) {
        let user = this.jwtUtilService.getDecodedToken().user;

        let isDrawn: boolean = false;
        if (!isDrawn) {
            this.doPinItem($event);
        }
        isDrawn = true;
    }

    private doPinItem($event) {
        let target = angular.element($event.target);
        let elem = target.parent('md-button').parent();

        // get favorites button position in the top header
        let destinationLoc = angular.element(document.getElementById('fixed-buttons-holder'));
        let destination = angular.element(document.getElementById('favorites-button'));
        let destX = destinationLoc.prop('offsetLeft') + this.$window.pageXOffset + 8;
        let destY = destinationLoc.prop('offsetTop') + this.$window.pageYOffset + -1;

        // get clicked pin button position
        let origin = elem[0].getBoundingClientRect();
        let origX = origin.left - 1;
        let origY = origin.top + 1 + this.$window.pageYOffset;

        // create the element to insert at the position of the clicked button
        let myElement = angular.element(
            '<div class="pinDummy" style="top:' + origY + 'px; left:' + origX + 'px">\
              <prm-icon>\
                  <md-icon>\
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="100%" height="100%" viewBox="0 0 24 24" fit="" preserveAspectRatio="xMidYMid meet" focusable="false"><path d="M16,12V4H17V2H7V4H8V12L6,14V16H11.2V22H12.8V16H18V14L16,12Z"></path></svg>\
                  </md-icon>\
              </prm-icon>\
          </div>'
        );

        // append the element to the DOM (body)
        angular.element(document.body).append(myElement);

        // change coordinates to that of the favorites button (will animate per CSS)
        this.$timeout(function() {
            myElement.addClass('animating');
        }, 0);

        this.$timeout(function() {
            myElement.css({
                top: destY + 'px',
                left: destX + 'px'
            });
        }, 100);

        this.$timeout(function() {
            destination.addClass('animating');
        }, 600);

        //remove the element from the DOM
        this.$timeout(function() {
            myElement.remove();
        }, 2000);

        this.$timeout(function() {
            destination.removeClass('animating')
        }, 1800);

        this.favoritesWarningMessageService.showMessage();
    }

    public pickBulkSizeData(selectedBulk) {
        this.pageBulkSizeEvent.emit(selectedBulk);
    }

    public showTopPagination() {
        if (this.uiType == 'widget') {
            return false;
        }
        return true;
    }


    public isDiscoveryLocalNoLogin() {
        return this.configurationUtil.getDiscoveryLocalNoLogin();

    }
    public isDiscoveryServicePage() {
        return this.configurationUtil.getDiscoveryServicesPage();
    }

    public isDiscoveryWithExternalNoLogin() {
        return this.configurationUtil.getDiscoveryWithExternalNoLogin();
    }

    get isRapidoSAEnabled() {
        return this.configurationUtil.getRapidoSAEnabled()
    }

    public hidePageNumber() {
        return (this.totalResultsNum <= this.pageSize && !this.hasMoreResults);
    }

    public exportAllButtonClicked(){
        if (this.userLoggedIn()){
            this.switchShowExportAllBox();
        } else {
            this.loginService.handleLoginClick();
        }      
    }

    private userLoggedIn(){
        return this.userSessionManagerService.getUserName().length > 0;
    }

    private focusChangeFormatDropdown() {
        let element = document.getElementById('exportAllFormatDropdown');
	    if (element) {
			element.focus();
		}
	}

}




// WEBPACK FOOTER //
// ./src/main/webapp/components/search/searchResult/searchResultToolBar/searchResultToolBar.directive.ts